module.exports = __webpack_public_path__ + "36eb77f4b56f4f14e401ed8cfcb91ff9.pdf";